import { render, staticRenderFns } from "./FeatureHead.vue?vue&type=template&id=a943b322&scoped=true&"
import script from "./FeatureHead.vue?vue&type=script&lang=js&"
export * from "./FeatureHead.vue?vue&type=script&lang=js&"
import style0 from "./FeatureHead.vue?vue&type=style&index=0&id=a943b322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a943b322",
  null
  
)

export default component.exports